"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
var _typeof = require("@babel/runtime/helpers/typeof");
exports.__esModule = true;
exports.getSelectedValue = exports.default = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _react = _interopRequireWildcard(require("react"));
var _lodash = require("lodash");
var _reactSvg = require("react-svg");
var _Button = _interopRequireDefault(require("../../Atoms/Button"));
var _Select = _interopRequireDefault(require("../../Atoms/Select"));
function _getRequireWildcardCache(nodeInterop) {
  if (typeof WeakMap !== "function") return null;
  var cacheBabelInterop = new WeakMap();
  var cacheNodeInterop = new WeakMap();
  return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) {
    return nodeInterop ? cacheNodeInterop : cacheBabelInterop;
  })(nodeInterop);
}
function _interopRequireWildcard(obj, nodeInterop) {
  if (!nodeInterop && obj && obj.__esModule) {
    return obj;
  }
  if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") {
    return {
      default: obj
    };
  }
  var cache = _getRequireWildcardCache(nodeInterop);
  if (cache && cache.has(obj)) {
    return cache.get(obj);
  }
  var newObj = {};
  var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;
  for (var key in obj) {
    if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) {
      var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;
      if (desc && (desc.get || desc.set)) {
        Object.defineProperty(newObj, key, desc);
      } else {
        newObj[key] = obj[key];
      }
    }
  }
  newObj.default = obj;
  if (cache) {
    cache.set(obj, newObj);
  }
  return newObj;
}
var getSelectedValue = function getSelectedValue(countryName, countries) {
  var seletedCountry = countries == null ? void 0 : countries.filter(function (item) {
    return item.title === countryName;
  });
  return seletedCountry.length ? seletedCountry[0] : countries[0];
};
exports.getSelectedValue = getSelectedValue;
var CountrySelection = function CountrySelection(props) {
  var config = props.config,
    appHostPath = props.appHostPath,
    onChange = props.onChange,
    onClose = props.onClose,
    countryName = props.countryName,
    language = props.language,
    isEProcurementApp = props.isEProcurementApp,
    localeLanguage = props.localeLanguage,
    _props$countries = props.countries,
    countries = _props$countries === void 0 ? [] : _props$countries,
    _props$languageList = props.languageList,
    languageList = _props$languageList === void 0 ? [] : _props$languageList,
    _props$translations = props.translations,
    translations = _props$translations === void 0 ? {} : _props$translations,
    _props$isLanguageList = props.isLanguageListJSON,
    isLanguageListJSON = _props$isLanguageList === void 0 ? false : _props$isLanguageList;
  var _useState = (0, _react.useState)(''),
    initialCountry = _useState[0],
    setInitialCountry = _useState[1];
  var _useState2 = (0, _react.useState)(''),
    initialLanguage = _useState2[0],
    setInitialLanguage = _useState2[1];
  var _useState3 = (0, _react.useState)(''),
    selectedCountry = _useState3[0],
    setSelectedCountry = _useState3[1];
  var _useState4 = (0, _react.useState)(''),
    selectedCountryCode = _useState4[0],
    setSelectedCountryCode = _useState4[1];
  var _useState5 = (0, _react.useState)(''),
    selectedLanguage = _useState5[0],
    setSelectedLanguage = _useState5[1];
  var _useState6 = (0, _react.useState)(languageList || []),
    selectedLanguageList = _useState6[0],
    setSelectedLanguageList = _useState6[1];
  var globeIcon = config.globeIcon;
  var preferredCountryHeading = translations.preferredCountryHeading,
    changeCountryText = translations.changeCountryText,
    formCountryLabel = translations.formCountryLabel,
    changeCountryNoteText = translations.changeCountryNoteText,
    changeCountryNewTabText = translations.changeCountryNewTabText,
    changeCountryButton = translations.changeCountryButton,
    cancelButton = translations.cancelButton,
    languageText = translations.languageText;
  _react.default.useEffect(function () {
    var selectCountry = isLanguageListJSON ? {} : getSelectedValue(countryName, countries);
    var languageCode = (0, _lodash.get)(language, 'languageCode', '');
    var href = selectCountry.href,
      countryCode = selectCountry.countryCode;
    setInitialCountry(href);
    setSelectedCountry(href);
    setSelectedCountryCode(countryCode);
    setInitialLanguage(languageCode);
    setSelectedLanguage(languageCode);
    setSelectedLanguageList(languageList);
  }, []);
  var handleDropdownChange = function handleDropdownChange(e) {
    var code = (0, _lodash.get)(e, ['target', 'value'], '');
    setSelectedCountry(code);
    var countryData = (0, _lodash.find)(countries, function (item) {
      return item.href === code;
    });
    if (!(0, _lodash.isEmpty)(countryData)) {
      var countryCode = countryData.countryCode,
        _countryData$language = countryData.languages,
        languages = _countryData$language === void 0 ? [] : _countryData$language;
      var languageCode = (0, _lodash.get)(languages, ['0', 'languageCode'], '');
      var defaultLanguageCode = (0, _lodash.find)(languages, function (item) {
        return item.languageCode === localeLanguage;
      });
      languageCode = (0, _lodash.get)(defaultLanguageCode, ['languageCode'], languageCode);
      setSelectedCountryCode(countryCode);
      setSelectedLanguage(languageCode);
      setSelectedLanguageList(languages);
    }
  };
  var handleLanguageDropdownChange = function handleLanguageDropdownChange(e) {
    setSelectedLanguage(e.target.value);
  };
  var getStoreUrl = function getStoreUrl() {
    var pathname = window.location.pathname;
    var pathList = pathname.split('/');
    var path = pathList.pop();
    var linkURL = "/store/" + selectedCountryCode + "/" + selectedLanguage + "/" + path;
    if (isEProcurementApp) {
      linkURL = "/store/" + selectedLanguage + "/" + path;
    }
    return linkURL;
  };
  var getURL = function getURL() {
    var locale = selectedCountryCode + "/" + selectedLanguage;
    var defaultUrl = "nextgen/" + locale + ".html";
    var url = (0, _lodash.find)(selectedLanguageList, function (item) {
      return (0, _lodash.toLower)(item.languageCode) === (0, _lodash.toLower)(selectedLanguage);
    });
    return (0, _lodash.get)(url, ['href'], defaultUrl);
  };
  var handleButtonClick = function handleButtonClick() {
    var url = selectedCountry;
    var openNewTab = true;
    if (initialCountry === selectedCountry && initialLanguage === selectedLanguage) {
      return onClose();
    }
    if (initialCountry === selectedCountry && initialLanguage !== selectedLanguage) {
      url = getStoreUrl();
      openNewTab = false;
    }
    if (initialCountry !== selectedCountry) {
      url = getURL();
    }
    onChange(url, openNewTab);
  };
  var Items = function Items() {
    return props.countries.map(function (country) {
      return _react.default.createElement("option", {
        key: country.href,
        value: country.href,
        "aria-label": country.title,
        "data-locator": "cmp-country-selector__dropdown-option"
      }, country.title);
    });
  };
  var LanguageItems = function LanguageItems() {
    return selectedLanguageList.length > 0 && selectedLanguageList.map(function (item) {
      return _react.default.createElement("option", {
        key: item.languageCode,
        value: item.languageCode,
        "aria-label": item.title,
        "data-locator": "cmp-country-selector__dropdown-option"
      }, item.title);
    });
  };
  return _react.default.createElement("div", {
    className: "row cmp-country-selector",
    "data-locator": "cmp-country-selector"
  }, _react.default.createElement("div", {
    className: "cmp-country-selector__title"
  }, _react.default.createElement(_reactSvg.ReactSVG, {
    src: globeIcon,
    "data-locator": "header-icon",
    wrapper: "span"
  }), _react.default.createElement("span", {
    className: "global-site-header-text",
    "data-locator": "select-your-global-site"
  }, preferredCountryHeading)), _react.default.createElement("span", {
    className: "cmp-country-selector__text change-country-text",
    "data-locator": "cmp-country-selector__text"
  }, changeCountryText), !isLanguageListJSON && _react.default.createElement("div", {
    className: "cmp-country-selector__dropdown"
  }, _react.default.createElement("label", {
    className: "select-label",
    "data-locator": "select-label"
  }, formCountryLabel), _react.default.createElement(_Select.default, (0, _extends2.default)({
    className: "default-dropdown country-dropdown",
    value: selectedCountry
  }, {
    onChange: handleDropdownChange
  }, {
    elementLocator: "select-css",
    ariaLabel: "footer country selector dropdown"
  }), _react.default.createElement(Items, null))), selectedLanguageList.length > 1 && _react.default.createElement("div", {
    className: "cmp-country-selector__dropdown"
  }, _react.default.createElement("label", {
    className: "select-label",
    "data-locator": "select-label"
  }, languageText), _react.default.createElement(_Select.default, (0, _extends2.default)({
    className: "default-dropdown state-dropdown",
    value: selectedLanguage
  }, {
    onChange: handleLanguageDropdownChange
  }, {
    elementLocator: "select-css",
    ariaLabel: "footer country selector dropdown"
  }), _react.default.createElement(LanguageItems, null))), selectedLanguageList.length === 1 && _react.default.createElement("div", {
    className: "cmp-country-selector__text single-language"
  }, _react.default.createElement("label", {
    className: "select-label",
    "data-locator": "select-label"
  }, languageText + ":"), _react.default.createElement("label", {
    className: "select-label cmp-language-label",
    "data-locator": "cmp-language-label"
  }, (0, _lodash.get)(selectedLanguageList, ['0', 'title'], ''))), !isLanguageListJSON && _react.default.createElement("div", {
    className: "cmp-country-selector__note"
  }, _react.default.createElement(_reactSvg.ReactSVG, {
    src: appHostPath + "/content/dam/waters/en/brand-assets/icons/externallink.svg"
  }), _react.default.createElement("div", {
    className: "cmp-country-selector__note-text",
    "data-locator": "cmp-country-selector__note"
  }, _react.default.createElement("span", {
    "data-locator": "cmp-country-selector__note-text"
  }, changeCountryNoteText, ': '), changeCountryNewTabText)), _react.default.createElement("div", {
    className: "cmp-country-selector__button center-xs",
    "data-locator": "cmp-country-selector__button"
  }, _react.default.createElement(_Button.default, (0, _extends2.default)({
    className: "primary"
  }, {
    onClick: handleButtonClick
  }), changeCountryButton)), _react.default.createElement("div", {
    className: "cmp-country-selector__cancel",
    "data-locator": "cmp-country-selector__cancel"
  }, _react.default.createElement(_Button.default, {
    className: "text",
    onClick: onClose
  }, cancelButton)));
};
CountrySelection.defaultProps = {
  countries: [],
  translations: {},
  onChange: function onChange() {
    /* default onChange handler */
  },
  onClose: function onClose() {
    /* default onClose handler */
  },
  appHostPath: '',
  countryName: '',
  isEProcurementApp: false,
  localeLanguage: '',
  isLanguageListJSON: false
};
var _default = CountrySelection;
exports.default = _default;